import { UserStorage } from '../classes/user-storage'

export const userStorage = new UserStorage()
